import { createAsyncThunk } from '@reduxjs/toolkit';

import { earningsAPI } from '@/modules/earning/api';
import type { TPeriodName } from '@/modules/earning/model';
import { namespace } from '@/modules/earning/namespace';

import { setEarnings } from '../actions';

const loadEarnings = createAsyncThunk(
  `${namespace}/load-earnings`,
  async ({ periodName }: { periodName: TPeriodName }, { dispatch }) => {
    const earnings = await earningsAPI.fetchEarnings({ periodName });

    dispatch(setEarnings(earnings));

    return earnings;
  },
);

export { loadEarnings };
